import { render, staticRenderFns } from "./Reading.vue?vue&type=template&id=95fd3670&scoped=true&"
import script from "./Reading.vue?vue&type=script&lang=js&"
export * from "./Reading.vue?vue&type=script&lang=js&"
import style0 from "./Reading.vue?vue&type=style&index=0&id=95fd3670&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95fd3670",
  null
  
)

export default component.exports